import _ from "lodash";

import { api, fetchRespJson, postData } from "apis/base";

export default {
  getUnitInfo,
  getUnitDetail,
  searchUnits,
  getUnitTags,
  getUnitFullpathHashList,
  getBenchmarkUprReport,
  getAppliedUprReport,
  getBenchmarkFirstRuleReport,
  getAllUnitTags,
  getUnitSnapshotReportByUnitId,
  getUnitSnapshotReports,
};

async function getUnitSnapshotReportByUnitId({ unitId }) {
  let apiUrl = `${api}/unit/${unitId}/snapshot-report`;
  const r = await fetchRespJson(apiUrl);
  return r;
}

// { unitIds }
async function getUnitSnapshotReports(params) {
  let apiUrl = `${api}/unit-snapshot-reports`;
  return await postData(apiUrl, params);
}

async function getAllUnitTags() {
  let apiUrl = `${api}/unit-tags`;
  const r = await fetchRespJson(apiUrl);
  return r;
}

async function getBenchmarkFirstRuleReport({ unitId, startDate }) {
  let apiUrl = `${api}/unit/${unitId}/benchmark-firstlook-report?startDate=${startDate}`;
  const r = await fetchRespJson(apiUrl);
  return r;
}

async function getBenchmarkUprReport({ unitId, startDate }) {
  let apiUrl = `${api}/unit/${unitId}/benchmark-upr-report?startDate=${startDate}`;
  const r = await fetchRespJson(apiUrl);
  return r;
}

async function getAppliedUprReport({ unitId, startDate }) {
  let apiUrl = `${api}/unit/${unitId}/applied-upr-report?startDate=${startDate}`;
  const r = await fetchRespJson(apiUrl);
  return r;
}

async function getUnitFullpathHashList({ networkId }) {
  let apiUrl = `${api}/network/${networkId}/units-fullpath-hash`;
  return await fetchRespJson(apiUrl);
}

async function getUnitTags({ unitId }) {
  let apiUrl = `${api}/unit/${unitId}/tags`;
  const { tags } = await fetchRespJson(apiUrl);
  return tags;
}

async function searchUnits(params) {
  let apiUrl = `${api}/network/${params.networkId}/units-search`;
  return await postData(apiUrl, params);
}

async function getUnitDetail({ unitId }) {
  let apiUrl = `${api}/unit/${unitId}/detail-info`;
  // unit tags included in this api
  const unitInfo = await fetchRespJson(apiUrl);
  return unitInfo;
}

async function getUnitInfo({ unitId }) {
  let apiUrl = `${api}/unit/${unitId}/info`;
  const unitInfo = await fetchRespJson(apiUrl);
  unitInfo.billableDemandTypes = JSON.parse(unitInfo.billableDemandTypes);
  return unitInfo;
}
